import React from 'react';
import QuestionGroupHeader from '../QuestionGroupHeader.jsx';
import classnames from 'classnames';
import ReduxBuilder from './BuilderConnected.jsx';
import builderGetLinkedQuestions from '../../../util/builderGetLinkedQuestions.mjs';
import {FormattedMessage, useIntl} from 'react-intl';
import {QuestionGroupViewPropTypes} from '../../../shapes/index';
import {useText} from '../../TextContext';

const Builder = ({questionGroup, className, renderQuestion, customProps}) => {
  const intl = useIntl();
  const textContext = useText();
  const builderOptions = questionGroup.questions.find(q => q.appkey === questionGroup.attributes.questionGroupKey);
  const label = textContext?.[`${builderOptions.appkey}`] || <FormattedMessage id={builderOptions.appkey} />;

  const prepareRows = () => {
    return (builderOptions.answers || []).map(row => {
      const messageKey = `${builderOptions.appkey}.${row.key}`;
      return {
        id: row.key,
        label: textContext?.[`${messageKey}`] || intl.formatMessage({id: messageKey}),
        questions: builderGetLinkedQuestions(questionGroup, row.attributes.linkedQuestions || []),
      };
    });
  };

  const classes = classnames(className, 'questionGroup--builder');

  const builderProps = {
    attributes: questionGroup.attributes,
    builderLinkedQuestions: prepareRows(),
    builderOptions,
    renderGoalLabel: <span>{label}</span>,
    renderLinkedQuestion: renderQuestion,
    showAllMode: questionGroup?.attributes?.showAllMode || questionGroup?.attributes?.checkboxMode || false,
    ...customProps,
  };

  return (
    <section className={classes}>
      <QuestionGroupHeader questionGroup={questionGroup} />
      <section>
        <ReduxBuilder questionGroup={questionGroup} {...builderProps} />
      </section>
    </section>
  );
};

Builder.propTypes = QuestionGroupViewPropTypes;

export default Builder;
